import clsx from "clsx";

export const Input = ({
  type = "text",
  placeholder,
  label,
  className,
  inputClass,
  leadingIcon,
  ...props
}) => {
  return (
    <div className={clsx("relative", className)}>
      <label className="text-sm text-[#FFFFFF] mb-3.5 inline-block">
        {label}
      </label>
      {leadingIcon}
      <input
        type={type}
        placeholder={placeholder}
        className={clsx("rmc_input", inputClass)}
        {...props}
      />
    </div>
  );
};
